import Slider from "./Slider";
import { Feature, TrackingLabels } from "../../types/Tracking";
import { resolveLinkType } from "../ProductTileClickHandling";

export default class RatingSlider extends Slider {
  protected type = "RATING";
  private typeBlackFriday = "RATING_BLACK_FRIDAY";

  protected getPathSegment() {
    return "rating-slider";
  }

  protected isType(type: string | undefined) {
    return this.type === type || this.typeBlackFriday === type;
  }

  protected getClickTrackingLabel(position: number, ev: MouseEvent): TrackingLabels {
    if (this.avContent) {
      return {
        san_Interaction: "rating_slider_product_tile",
        "wk.san_ProductClickListType": this.avContent.dataset.pt,
        "wk.san_ProductLinkType": resolveLinkType(ev),
        "wk.san_ProductType": "rating_slider",
        "wk.san_SliderPosition": +position,
      };
    }

    return {};
  }

  protected prepareFeatureTracking(currentSlides: number[], baseTrackingLabels: TrackingLabels): Feature[] {
    return [
      <Feature>{
        id: "san_rating_slider",
        name: "Rating-Slider",
        status: "loaded",
        labels: baseTrackingLabels,
      },
    ].concat(
      currentSlides.map((index) => {
        const tile: HTMLElement = document.getElementsByClassName(this.sliderItemClassName).item(index) as HTMLElement;
        const position = tile.dataset.position || "";
        const variationCount = tile.dataset.variationCount || "";
        return <Feature>{
          id: "san_rating_tile_" + position,
          name: "Rating-Slider-Tile",
          status: "loaded",
          parentId: "san_rating_slider",
          position: +position,
          variationId: tile.dataset.variationId,
          labels: {
            san_ProductType: "rating_slider",
            san_VariationCount: +variationCount,
          },
        };
      }),
    );
  }
}
